import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { WiRaindrops } from "react-icons/wi";
import { SiSlashdot } from "react-icons/si";
import { CiBitcoin } from "react-icons/ci";
import { BsEmojiSmile } from "react-icons/bs";
import EmojiPicker from 'emoji-picker-react';
import { MdAdd, MdSend } from "react-icons/md";
import Gif from "../../../components/common/Gif";
import socket from "utils/Socket";
import storage from "utils/Storage";
import { Event } from 'utils/Helper';
import C from 'utils/Constant';
import { setGif } from "actions/gameChat";

class Submit extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            isLogged: storage.getKey('logged') !== null,
            country: "GLOBAL",
            showEmojiPicker: false,
            showChatBottom: false,
            isTextareaActive: false,
        };
    }

    // Toggle chat dropdown visibility
    toggleChatBottom = () => {
        this.setState(prevState => ({
            showChatBottom: !prevState.showChatBottom
        }));
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setState({ [name]: value });
    };

    submit = (e) => {
        e.preventDefault();
        if (this.state.message.trim() === '') return;

        const activeRoom = (this.props.country && (this.props.country.toLowerCase() === "br" || this.props.country.toLowerCase() === "spam")) ? "brazil" : "global";
        socket.emit(C.ADD_CHAT, { message: this.state.message, country: activeRoom });
        this.setState({ message: '', isTextareaActive: false });
        Event.emit('scrolldone');
    };

    handleSubmit = (e) => {
        if (e.which === 13) {
            this.submit(e);
        }
    };

    toggleEmojiPicker = () => {
        this.setState(prevState => ({ showEmojiPicker: !prevState.showEmojiPicker }));
    };

    onEmojiClick = (emojiData) => {
        this.setState(prevState => ({
            message: prevState.message + emojiData.emoji,
            showEmojiPicker: false
        }));
    };

    handleTextareaFocus = () => {
        this.setState({ isTextareaActive: true });
    };

    handleTextareaBlur = () => {
        if (this.state.message.trim() === '') {
            this.setState({ isTextareaActive: false });
        }
    };

    componentDidUpdate(prevProps) {
        if (prevProps.gif !== this.props.gif && this.props.gif) {
            const activeRoom = (this.props.country && (this.props.country.toLowerCase() === "br" || this.props.country.toLowerCase() === "spam")) ? "brazil" : "global";
            socket.emit(C.ADD_CHAT, { message: this.props.gif, country: activeRoom });
            Event.emit('scrolldone');
            this.props.setGif(null);
        }
    }

    render() {
        const { t } = this.props;
        return (
            <div style={{ position: "relative", width: "100%", bottom: 0, margin: 0, padding: 0 }}>
                <style>{`
                    .textarea-new {
                        background-color: transparent !important;
                        background: transparent !important;
                        border: none !important;
                        box-shadow: none !important;
                        outline: none !important;
                        color: white !important;
                        resize: none !important;
                        width: 100% !important;
                        height: 24px !important;
                        line-height: 24px !important;
                        padding: 0 !important;
                        margin: 0 !important;
                    }
                    .textarea-new:focus {
                        background-color: transparent !important;
                        background: transparent !important;
                        border: none !important;
                        box-shadow: none !important;
                        outline: none !important;
                    }
                    .textarea-new::placeholder {
                        color: #8e969f !important;
                    }
                `}</style>
                <form onKeyPress={this.handleSubmit} style={{ margin: 0, padding: 0 }}>
                    <div style={{
                        backgroundColor: "#0f212e",
                        padding: "10px 8px 10px 8px",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                        gap: "8px",
                        width: "100%"
                    }}>
                        {/* Rectangular Input Container */}
                        <div style={{ 
                            display: 'flex', 
                            alignItems: "center", 
                            backgroundColor: "#1a2c38", 
                            borderRadius: "8px", // rectangular style restored
                            padding: "8px 12px", 
                            flexGrow: 1, 
                            gap: "8px",
                            border: "1px solid #2f4553"
                        }}>
                            {this.state.isLogged ? (
                                <textarea
                                    style={{ 
                                        flexGrow: 1, 
                                        height: "24px", 
                                        lineHeight: "24px",
                                        padding: 0,
                                        fontSize: "13px",
                                        overflow: "hidden"
                                    }}
                                    onChange={this.handleChange}
                                    autoComplete="off"
                                    name="message"
                                    className="textarea-new"
                                    placeholder={t('Your Message...')}
                                    value={this.state.message}
                                    onFocus={this.handleTextareaFocus}
                                    onBlur={this.handleTextareaBlur}
                                />
                            ) : (
                                <textarea
                                    style={{ 
                                        flexGrow: 1, 
                                        height: "24px", 
                                        lineHeight: "24px",
                                        padding: 0,
                                        fontSize: "13px",
                                        overflow: "hidden"
                                    }}
                                    disabled
                                    autoComplete="off"
                                    className="textarea-new"
                                    placeholder={t('Your Message')}
                                    value={t('please_login_to_use_chat')}
                                />
                            )}

                            {/* Inline icons on the right */}
                            <div style={{ display: "flex", alignItems: "center", gap: "8px", flexShrink: 0 }}>
                                <BsEmojiSmile
                                    fontSize="18px"
                                    onClick={this.toggleEmojiPicker}
                                    style={{ cursor: 'pointer', color: "#b1bad3" }}
                                />
                                <Gif />
                                {this.state.showEmojiPicker && (
                                    <div className="emoji-picker" style={{ position: "absolute", bottom: "75px", right: "60px", zIndex: 1010 }}>
                                        <EmojiPicker
                                            style={{ background: "#0f212e", border: "1px solid rgba(255,255,255,0.08)" }}
                                            height={300}
                                            width={300}
                                            onEmojiClick={this.onEmojiClick}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Circular Send Button */}
                        <button
                            className="btn btn-toggle-chat"
                            onClick={this.submit}
                            type="button"
                            style={{
                                background: "#25de82",
                                border: "none",
                                cursor: "pointer",
                                height: "36px",
                                width: "36px",
                                minWidth: "36px",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                borderRadius: "50%",
                                transition: "all 0.2s ease",
                                boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)"
                            }}
                        >
                            <MdSend fontSize="18px" color="#0f212e" />
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

Submit.propTypes = {
    name: PropTypes.string,
    country: PropTypes.string,
    gif: PropTypes.string,
    setGif: PropTypes.func
};

const mapStateToProps = state => ({
    name: state.items.name,
    country: state.items.country,
    gif: state.items.gif
});

export default connect(mapStateToProps, { setGif })(Submit);
